import axios from "axios";
import qs from "qs";
import { Loading } from 'element-ui';
//添加请求拦截器
axios.interceptors.request.use(config => {
        // let token = window.localStorage.getItem("accessToken")
        // if (token) {
        //将token放到请求头发送给服务器,将tokenkey放在请求头中
        // config.headers.token = token;
        // }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
//添加响应拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.resolve(error.response);
    }
);

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.timeout = 10000000;

// function checkStatus(response) {
//     return new Promise((resolve, reject) => {
//         if (
//             response &&
//             (response.status === 200 || response.status === 304 || response.status === 400)
//         ) {
//             resolve(response.data);
//         } else {
//             reject({
//                 state: "0",
//                 message: "网络出现问题"
//             });
//         }
//     });
// }
export default {
    post(url, params) {
        let loadingInstance = Loading.service();
        return axios({
            method: "post",
            url,
            data: params
        }).then(response => {
            // return checkStatus(response);
            loadingInstance.close();
            return response;
        });
    },
    get(url, params) {
        let loadingInstance = Loading.service();
        return axios({
            method: "get",
            url,
            params
        }).then(response => {
            loadingInstance.close();
            // return checkStatus(response);
            return response;
        });
    },
    upLoudFile(url, params) {
        let loadingInstance = Loading.service();
        // params = qs.stringify(params);
        return axios({
            method: "upLoudFile",
            url,
            params
        }).then(response => {
            // return checkStatus(response);
            loadingInstance.close();
            return response;
        });
    },
    delete(url, params) {
        // params = qs.stringify(params);
        return axios({
            method: "delete",
            url: url,
            params: params, // 请求参数拼接在url上
            data: params
        }).then(response => {
            // return checkStatus(response);
            return response;
        });
    },
}



// WEBPACK FOOTER //
// ./src/api/index.js